/**
 * Mock Transport for Development/Testing
 */

import { Code, ConnectError, createRouterTransport } from '@connectrpc/connect';
import {
  LoginResponseSchema,
  LogoutResponseSchema,
  RefreshTokenResponseSchema,
  UserService,
  UserSchema,
} from '@puppycad/proto';
import { create } from '@bufbuild/protobuf';

export const mockTransport = createRouterTransport(({ service }) => {
  service(UserService, {
    // Login: Returns LoginResponse with proto-compliant User shape
    login: (req) => {
      if (req.username === 'admin') {
        // Create proto User object
        const mockUser = create(UserSchema, {
          id: 1n, // bigint for uint64
          username: 'admin',
          displayName: 'Admin User',
          avatarUrl: '',
          email: 'admin@puppycad.com',
          phone: '',
          is2faEnabled: false,
          roleAccess: undefined,
        });
        
        // 返回值按生成 schema 创建，确保开发 mock 与后端协议同步。
        return create(LoginResponseSchema, {
          accessToken: 'mock-access-token',
          user: mockUser,
        });
      }
      
      // Mock error case
      throw new ConnectError(
        'Invalid username or password',
        Code.Unauthenticated
      );
    },
    
    // GetProfile: Sprint 02 C1 contract
    getProfile: () => {
      // Return mock user profile
      const mockUser = create(UserSchema, {
        id: 1n,
        username: 'admin',
        displayName: 'Admin User',
        avatarUrl: '',
        email: 'admin@puppycad.com',
        phone: '',
        is2faEnabled: false,
        roleAccess: undefined,
      });
      return mockUser;
    },
    
    // RefreshTokens: Sprint 02 C2 contract
    refreshTokens: () => {
      // Valid refresh request (token validation assumed via cookie/header)
      // refresh token 由 HttpOnly Cookie 承载，响应体只返回新的 accessToken。
      return create(RefreshTokenResponseSchema, {
        accessToken: 'mock-new-access-token-' + Date.now(),
      });
    },
    
    // Logout: Sprint 02 C3 contract
    logout: () => {
      // Mock success: Server-side token revocation
      // Returns empty LogoutResponse
      return create(LogoutResponseSchema, {});
    },
  });
});

